/* eslint-disable */
import LazySizes from 'lazysizes';
/* eslint-enable */
import { onDocumentReady } from './utils';

// Components
import Links from './components/links';
import BrowserVars from './components/browser-vars';
import AnimateIn from './components/animate-in';
import Parallax from './components/parallax';
import ChargeAnim from './components/charge';

onDocumentReady(() => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Run animations if the user has not requested reduced motion
  if (!prefersReducedMotion.matches) {
    new BrowserVars();

    if (document.querySelectorAll('.js-parallax')) {
      document.querySelectorAll('.js-parallax').forEach(dom => {
        new Parallax(dom);
      });
    }
  }

  new Links();
  new AnimateIn();
  new ChargeAnim();

  if (document.querySelector('.js-hang-punc')) {
    import(/* webpackChunkName: "hang-punctuation" */ './components/hang-punctuation').then(
      module => {
        const HangPunctuation = module.default;
        new HangPunctuation();
      },
    );
  }

  // only run in development environment
  if (process.env.NODE_ENV === 'development') {
    import(/* webpackChunkName: "toggle-grid" */ './components/toggle-grid').then(module => {
      const ToggleGrid = module.default;
      new ToggleGrid();
    });
  }
});
